import * as modalActions from 'ha/modules/ModalsLogic/actions';

import { analytics } from 'ha/utils/Payouts';

import { MODAL_NAME } from '../constants';

interface AnalitycsParams {
  platformUserID: number;
  tenant_id?: number;
  conversation_id?: number;
}

// doesn't match dispatch type since `error: boolean` is required
export const openPaymentRequestModal = (props: AnalitycsParams) => ({
  ...modalActions.open(MODAL_NAME),
  error: false,
  meta: { analytics: analytics.formLoaded(props) },
});
export const closePaymentRequestModal = () => ({
  ...modalActions.close(MODAL_NAME),
  error: false,
});
